import {Box, Icon, Lottie, ThemeColorPath, ThemeIconKey, ThemeLottieKey} from 'platform/foundation';

import {useComponentsTheme} from '../../hooks/useComponentsTheme';

interface IconOrLottieProps {
  value: ThemeIconKey | ThemeLottieKey;
  color?: ThemeColorPath;
}

function isThemeIconKey(
  value: ThemeIconKey | ThemeLottieKey,
  icons: object
): value is ThemeIconKey {
  return Object.hasOwn(icons, value);
}

export function IconOrLottie(props: IconOrLottieProps) {
  const theme = useComponentsTheme();

  if (!isThemeIconKey(props.value, theme.icons)) {
    return (
      <Box width={4} height={4}>
        <Lottie value={props.value} minHeight={4} autoplay loop />
      </Box>
    );
  }

  return <Icon size={4} value={props.value} color={props.color} />;
}
